module.exports = __webpack_public_path__ + "img/aslogo.3e040d03.png";